module.exports = __webpack_public_path__ + "img/img10.738f05f9.png";